import dayjs from 'dayjs';
import { IGDSTStore } from './interfaces';
import * as actionTypes from './actionTypes';
import { convertTicketNum, getEarliestDate } from '@libs/core';

const initialState = {
    calendar: null,
    ticketNum: null,
    session: null,
    sessionPicked: null,
    totalAmount: '0',
    totalAmountN: 0,
    salePriceSpread: 0,
    showCrossellTag: true,
    GDetail: null,
    GTempCalendarData: null,
    isTGDSDetailLoading: false,
    TGDSDetailFetchFail: false,
    isTGDSSessionLoading: false,
    TGDSSessionFetchFail: false,
    TGNowList: null,
    TGNowListData: null,
    TGMInfoShow: false,
    TGCalenderErr: '',
    TGSessionErr: '',
    TGTicketErr: '',
    Scrollto: null,
    submitWatcher: false,
    isSubmitSuccess: false,
    TGfinalAbleDates: [],
    TGSubmitErrMsg: '',
};

const reducer = (state: IGDSTStore = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_TGRESTORE:
            return { ...initialState };
        case actionTypes.SET_TGRESET:
            const { TGNowListData, GTempCalendarData, GDetail, TGfinalAbleDates } = state;
            const returnState = {
                ...state,
                calendar: getEarliestDate(TGfinalAbleDates)
                            ? dayjs(getEarliestDate(TGfinalAbleDates)).format('YYYY-MM-DD')
                            : null,
                TGCalenderErr: '',
                TGSessionErr: '',
                TGTicketErr: '',
                TGSubmitErrMsg: '',
            };
            // 先確定有無月曆
            const ETItem = TGNowListData.ExpectedUseDay
            ? GDetail.EarliestBuyDay // 與TGfinalAbleDates組成有關(min)
                ? GTempCalendarData[getEarliestDate(TGfinalAbleDates)]?.ETItem
                : GDetail.ETItem
            : GDetail.ETItem
            console.log("ETItem🤷‍♀️",ETItem)
            // 再重設票種張數(場次重設會重打API時設定)
            Object.assign(returnState, { ticketNum: convertTicketNum(ETItem) });
        
            return returnState;
        case actionTypes.SET_TGCALENDAR:
            return { ...state, calendar: action.payload };
        case actionTypes.SET_TGTICKECTNUM:
            return { ...state, ticketNum: action.payload };
        case actionTypes.SET_TGSESSION:
            return { ...state, session: action.payload };
        case actionTypes.SET_TGSESSIONPICKED:
            return { ...state, sessionPicked: action.payload };
        case actionTypes.SET_TGTOTALAMOUNT:
            return {
                ...state,
                totalAmount: action.payload,
                totalAmountN: Number(action.payload.replace(/,/g, '')),
            };
        case actionTypes.SET_SALEPRICESPREAD:
            return { ...state, salePriceSpread: action.payload };
        case actionTypes.SET_SHOWCROSSELL:
            return { ...state, showCrossellTag: action.payload };
        case actionTypes.SET_TGDETAIL:
            return { ...state, GDetail: action.payload };
        case actionTypes.SET_TGTEMPCALENDARDATA:
            return { ...state, GTempCalendarData: action.payload };
        case actionTypes.SET_ISTGDSDETAILLOADING:
            return { ...state, isTGDSDetailLoading: action.payload };
        case actionTypes.SET_TGDDETAILFETCHFAIL:
            return { ...state, TGDSDetailFetchFail: action.payload };
        case actionTypes.SET_ISTGDSSESSIONLOADING:
            return { ...state, isTGDSSessionLoading: action.payload };
        case actionTypes.SET_TGDSSESSIONFETCHFAIL:
            return { ...state, TGDSSessionFetchFail: action.payload };
        case actionTypes.SET_TGNOWLIST:
            return { ...state, TGNowList: action.payload };
        case actionTypes.SET_TGNOWLISTDATA:
            return { ...state, TGNowListData: action.payload };
        case actionTypes.SET_TGMINFOSHOW:
            return { ...state, TGMInfoShow: action.payload };
        case actionTypes.SET_TGCALENDARERR:
            return { ...state, TGCalenderErr: action.payload };
        case actionTypes.SET_TGSESSIONERR:
            return { ...state, TGSessionErr: action.payload };
        case actionTypes.SET_TGTICKETErr:
            return { ...state, TGTicketErr: action.payload };
        case actionTypes.SET_TGSCROLLTO:
            return { ...state, Scrollto: action.payload };
        case actionTypes.SET_TGSUBMITWATCHER:
            return { ...state, submitWatcher: action.payload };
        case actionTypes.SET_ISTGSUBMITSUCCESS:
            return { ...state, isSubmitSuccess: action.payload };
        case actionTypes.SET_TGFINALABLEDATES:
            return { ...state, TGfinalAbleDates: action.payload };
        case actionTypes.SET_TGSUBMITERRMSG:
            return { ...state, TGSubmitErrMsg: action.payload };
        default:
            return state;
    }
};

export default reducer;
